import { render, staticRenderFns } from "./MsgSystem.vue?vue&type=template&id=54d56228&scoped=true&"
import script from "./MsgSystem.vue?vue&type=script&lang=js&"
export * from "./MsgSystem.vue?vue&type=script&lang=js&"
import style0 from "./MsgSystem.vue?vue&type=style&index=0&id=54d56228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d56228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d56228')) {
      api.createRecord('54d56228', component.options)
    } else {
      api.reload('54d56228', component.options)
    }
    module.hot.accept("./MsgSystem.vue?vue&type=template&id=54d56228&scoped=true&", function () {
      api.rerender('54d56228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/MsgSystem.vue"
export default component.exports